import React from "react";
import { MLabel, MSelect, ValidatedForm } from "components/forms";
import { Col, Row } from "design-react-kit";
import ReactHtmlParser from "react-html-parser";

import { FormTitleTFAIndire } from "./enrollTFAIndire/FormTitleTFAIndire";
import { TitolareContrattoTFAIndire } from "./enrollTFAIndire/TitolareContrattoTFAIndire";
import { AbilitazioneTitoloEstero } from "./enrollTFAIndire/AbilitazioneTitoloEstero";
import { RiconoscimentoEstero } from "./enrollTFAIndire/RiconoscimentoEstero";
import { RinunciaRiconoscimentoEstero } from "./enrollTFAIndire/RinunciaRiconoscimentoEstero";
import { CourseHelper, enrollmentService, networkErrorHelper, payloadBuilder } from "libs";
import { ENROLLMENT_STEPS, QUALIFICATION_CODE } from "const";
import axios from "axios";

export class EnrollFillFormTFAIndire77 extends ValidatedForm {
  emptyFields = {
    examSite: 0,
    competitionClass: "",
  };

  PAYLOADS = {
    examSites: [
      { value: "", label: "Selezionare" },
      { value: "Calabria", label: "Calabria" },
      { value: "Campania", label: "Campania" },
      { value: "Emilia Romagna", label: "Emilia Romagna" },
      { value: "Lazio", label: "Lazio" },
      { value: "Lombardia", label: "Lombardia" },
      { value: "Piemonte", label: "Piemonte" },
      { value: "Puglia", label: "Puglia" },
      { value: "Sicilia", label: "Sicilia" },
      { value: "Toscana", label: "Toscana" },
      { value: "Veneto", label: "Veneto" },
    ],
    competitionClass: [{ label: "Seleziona classe di concorso", value: "-1" }],
  };

  FIELDS_GROUP = [
    [
      {
        field: "examSiteLabel",
        label: "1. SEDE ESAMI",
        infoText: "Seleziona una regione per lo svolgimento degli esami",
        component: MLabel,
        className: "col-md-6 pt-3",
      },
    ],
    [
      {
        field: "examSite",
        payload: { options: this.PAYLOADS.examSites },
        component: MSelect,
        className: "col-md-6",
      },
    ],
    [
      {
        field: "competitionClassLabel",
        label: "2. CLASSE DI CONCORSO",
        component: MLabel,
        className: "col-md-6 pt-3",
      },
    ],
    [
      {
        field: "competitionClass",
        payload: { options: this.PAYLOADS.competitionClass },
        component: MSelect,
        className: "col-md-6",
      },
    ],
  ];

  ERROR_MESSAGES = {
    examSite: "Specificare una sede esami",
    competitionClass: "Specificare una classe di concorso",
  };

  validation = {
    examSite: (value) => value > "",
    competitionClass: (value) => value > "" && value !== "-1",
  };

  constructor(props) {
    super(props);
    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  state = {
    _formRef_1_3: React.createRef(),
    _formRef_1_4: React.createRef(),
    _formRef_1_5: React.createRef(),
    _formRef_1_6: React.createRef(),
    _formRef_1_7: React.createRef(),
    loading: true,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    courseType: "",
    grado: "",
    validationSummary: "",
  };

  onSubmit = async () => {
    this.payload = payloadBuilder(this.state);
    let validationList = [];
    let qualifications = [];

    let isValid = true;

    // 1. SEDE ESAMI
    // 2. CLASSE DI CONCORSO
    const isValidForm = this.checkValidation();

    if (!isValidForm) {
      validationList.push("Inserire i campi obbligatori in rosso");
      isValid = false;
    }

    //Subforms validation
    const { _formRef_1_3, _formRef_1_4, _formRef_1_5, _formRef_1_6, _formRef_1_7 } = this.state;

    //3. TITOLO DI STUDIO
    if (_formRef_1_3 && _formRef_1_3.current != null) {
      const isStep3Valid = _formRef_1_3.current.onSubmit();

      if (isStep3Valid) {
        //get payload
        const payload13 = _formRef_1_3.current.getPayload();
        qualifications.push(payload13);
      } else {
        validationList.push("3. TITOLO DI STUDIO: Verificare i dati inseriti.");
        isValid = false;
      }
    }

    // 4. ABILITAZIONE
    if (_formRef_1_4 && _formRef_1_4.current != null) {
      const isStep4Valid = _formRef_1_4.current.onSubmit();

      if (isStep4Valid) {
        const payload14 = _formRef_1_4.current.getPayload();
        qualifications.push(payload14);
      } else {
        validationList.push("4. ABILITAZIONE: Verificare i dati inseriti.");
        isValid = false;
      }
    }

    // 5. RICONOSCIMENTO
    if (_formRef_1_5 && _formRef_1_5.current !== null) {
      const isStep5Valid = _formRef_1_5.current.onSubmit();
      if (isStep5Valid) {
        const payload15 = _formRef_1_5.current.getPayload();
        qualifications.push(payload15);
      } else {
        validationList.push("5. RICONOSCIMENTO: Verificare i dati inseriti.");
      }
    }

    // 6. RINUNCIA ALL'ISTANZA DI RICONOSCIMENTO
    if (_formRef_1_6 && _formRef_1_6.current !== null) {
      const isStep6Valid = _formRef_1_6.current.onSubmit();

      if (isStep6Valid) {
        const payload16 = _formRef_1_6.current.getPayload();
        qualifications.push(payload16);
      } else {
        validationList.push("6. RINUNCIA ALL'ISTANZA DI RICONOSCIMENTO: Verificare i dati inseriti.");
        isValid = false;
      }
    }

    // 7. ANZIANITÀ LAVORATIVA
    if (_formRef_1_7 && _formRef_1_7.current != null) {
      const isStep7Valid = _formRef_1_7.current.onSubmit();

      if (isStep7Valid) {
        const payload17 = _formRef_1_7.current.getPayload();
        qualifications.push(...payload17);
      } else {
        validationList.push("7. ANZIANITÀ LAVORATIVA: Verificare i dati inseriti.");
        isValid = false;
      }
    }

    isValid = isValid && isValidForm;

    if (isValid) {
      this.payload.qualifications = qualifications;

      const payloadQualification = {
        idEnrollment: this.props.enrollData.idEnrollment,
        currentStep: ENROLLMENT_STEPS.FILL,
        qualifications: qualifications,
      };

      try {
        await enrollmentService.updateEnrollmentQualification(payloadQualification);
      } catch (errors) {
        validationList.push("Errore imprevisto nell'invio dei dati. Se il problema persiste contattare il supporto tecnico.");
        networkErrorHelper.notify(errors);
        isValid = false;
      }
    }

    let validationSummary = "";
    if (validationList.length > 0) {
      validationSummary = "<ul><li>" + validationList.join("</li><li>") + "</li></ul>";
    }

    this.setState({ validationSummary: validationSummary });

    return isValid;
  };

  getPayload = () => {
    return this.payload;
  };

  getDefaultPayload = (qualifications) => {
    const defaultPayloads = {
      Title13: [],
      Title14_AbilitazioneEstero: [],
      Title15_Riconoscimento: [],
      Title15_Ricorso: [],
      Title16_RinunciaRiconoscimento: [],
      Title17Item_TITOLARE_CONTRATTO: [],
      Title17Item_TITOLARE_CONTRATTOLode: [],
    };

    const title13Templates = [
      "LaureaScienzeFormazionePrimariaVO",
      "LaureaScienzeFormazionePrimaria249",
      "DiplomaMagistrale0102",
      "DiplomaSperimentale0102_Psico",
      "DiplomaSperimentale0102_Ling",
      "ITP",
      ...Object.keys(QUALIFICATION_CODE),
    ];

    qualifications.forEach((q) => {
      const template = q.template;

      if (title13Templates.includes(template)) {
        defaultPayloads.Title13.push(q);
      } else {
        if (!defaultPayloads[template]) {
          defaultPayloads[template] = [];
        }
        defaultPayloads[template].push(q);
      }
    });

    //merge TitolareContratto with TitolareContrattoLode
    defaultPayloads.Title17Item_TITOLARE_CONTRATTO = [
      ...(defaultPayloads.Title17Item_TITOLARE_CONTRATTO || []),
      ...(defaultPayloads.Title17Item_TITOLARE_CONTRATTOLode || []),
    ];

    return defaultPayloads;
  };

  getCompetitionClasses = async (grado) => {
    try {
      const competitionClasses = await axios.get("/assets/json/competitionClassAndGrade.json");

      if (competitionClasses.data.length > 0) {
        this.PAYLOADS.competitionClass.length = 0;

        competitionClasses.data
          .filter((item) => {
            return item.grade === grado;
          })
          .forEach((item) => {
            this.PAYLOADS.competitionClass.push({
              label: item.competitionClass + " - " + item.subject,
              value: item.competitionClass,
            });
          });

        this.PAYLOADS.competitionClass.unshift({
          label: "Seleziona classe di concorso",
          value: "-1",
        });

        this.setState({
          PAYLOADS: { competitionClass: this.PAYLOADS.competitionClass },
        });
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };

  loadRemote() {
    const { idEnrollment, courseCode } = this.props.enrollData;
    const grado = CourseHelper.getGradoTFA(courseCode);

    this.getCompetitionClasses(grado);
    this.loadRemoteQualifications(idEnrollment);

    this.setState({ grado });
  }

  loadRemoteQualifications = (idEnrollment) => {
    enrollmentService
      .getEnrollmentQualifications(idEnrollment)
      .then(({ data }) => {
        const qualifications = data.payload?.qualifications || [];
        const defaultPayloads = this.getDefaultPayload(qualifications);

        this.setState({
          defaultValues: {
            ...this.state.defaultValues,
            examSite: this.props.enrollData.examSite || "",
            competitionClass: this.props.enrollData.competitionClass || "",
            ...defaultPayloads,
          },
          competitionClass: this.props.enrollData.competitionClass || "",
          loading: false,
        });
      })
      .catch((errors) => {
        this.setState({ loading: false });
        console.error(errors);
        networkErrorHelper.notify(errors);
      });
  };

  render() {
    const { loading, defaultValues, validationSummary, _formRef_1_3, _formRef_1_4, _formRef_1_5, _formRef_1_6, _formRef_1_7, grado } = this.state;
    const { idEnrollment } = this.props.enrollData;

    if (loading) return <></>;

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <div>
          <form>{code}</form>
        </div>
        <hr />

        <Row>
          <Col>
            <h6>3. TITOLO DI STUDIO</h6>
            <FormTitleTFAIndire grado={grado} defaultPayload={defaultValues.Title13} ref={_formRef_1_3} />
          </Col>
        </Row>

        <hr />

        <Row>
          <Col>
            <h6>4. ABILITAZIONE </h6>
            <AbilitazioneTitoloEstero ref={_formRef_1_4} enrollmentId={idEnrollment} defaultPayload={defaultValues.Title14_AbilitazioneEstero} />
          </Col>
        </Row>

        <hr />

        <Row>
          <Col>
            <h6>5. RICONOSCIMENTO</h6>
            <RiconoscimentoEstero
              ref={_formRef_1_5}
              enrollmentId={idEnrollment}
              defaultPayload={{
                riconoscimento: defaultValues.Title15_Riconoscimento,
                ricorso: defaultValues.Title15_Ricorso,
              }}
            />
          </Col>
        </Row>

        <hr />

        <Row>
          <Col>
            <h6>6. RINUNCIA ALL'ISTANZA DI RICONOSCIMENTO </h6>
            <RinunciaRiconoscimentoEstero
              ref={_formRef_1_6}
              enrollmentId={idEnrollment}
              defaultPayload={defaultValues.Title16_RinunciaRiconoscimento}
            />
          </Col>
        </Row>

        <hr />

        <Row>
          <Col>
            <h6>7. ANZIANITÀ LAVORATIVA</h6>
            <TitolareContrattoTFAIndire
              ref={_formRef_1_7}
              qualificationType="Title17Item"
              grado={grado}
              courseType="77"
              defaultPayload={defaultValues.Title17Item_TITOLARE_CONTRATTO}
            />
          </Col>
        </Row>

        <Row>
          <div className="w-100">
            {validationSummary && (
              <div className="alert alert-danger mt-3" role="alert">
                {ReactHtmlParser(validationSummary)}
              </div>
            )}
          </div>
        </Row>
      </>
    );
  }
}
